enum BritishColumbiaObstetricalFilePageIdEnum {
    Part1,
    Part2,
    Resources
}

export { BritishColumbiaObstetricalFilePageIdEnum };
